import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "@/components/site/Motion";
import { TrustBadges } from "@/components/site/TrustBadges";
import { useEnquiry } from "@/context/EnquiryContext";
import { IMG } from "@/data/site";
import { EImg, T } from "@/context/ContentContext";

export function GeorgiaFinale() {
  const ref = useRef(null);
  const { openEnquiry } = useEnquiry();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} className="relative overflow-hidden bg-wine-deep text-cream" data-testid="georgia-finale">
      <EImg as={motion.img} k="finale.img" style={{ y }} src={IMG.caucasus} alt="Caucasus mountains, Georgia" className="absolute inset-0 h-[124%] -top-[12%] w-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-r from-wine-deep via-wine-deep/70 to-transparent pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-7">
        <T k="finale.eyebrow" as="p" className="eyebrow text-gold mb-6">And the last word goes to</T>
        <h2 className="font-display font-extrabold tracking-[-0.05em] leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
          <MaskLines inView delay={0} lines={[<T k="finale.title.0">Georgia.</T>, <T k="finale.title.1" className="font-serif italic font-normal tracking-[-0.02em] text-gold">Always Georgia.</T>]} />
        </h2>
        <TrustBadges className="mt-6" />
        </div>
        <div className="lg:col-span-5 flex flex-wrap items-center lg:justify-end gap-5">
          <button onClick={() => openEnquiry({ destination: "Georgia" })} data-testid="finale-enquire-btn"
            className="rounded-full bg-terra text-paper px-7 py-4 font-semibold hover:bg-[#a5370a] transition-colors"><T k="finale.cta">Plan my Georgia trip</T></button>
          <Link to="/georgia" data-testid="finale-georgia-link" className="group inline-flex items-center gap-2 underline underline-offset-[6px] decoration-gold hover:text-gold">
            <T k="finale.link">Explore Georgia</T> <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </Link>
        </div>
      </div>
    </section>
  );
}
